import { MainProduct } from "../../../types";

export const getMainProductVariantById = (
  mainProduct: MainProduct, 
  activeMainProductVariantId: string
) => {
  const mainProductVariant = mainProduct.variants
    .find(pendantProductVariant => Number(pendantProductVariant.id) === Number(activeMainProductVariantId))

  return mainProductVariant
}

export const getPendantProductVariantById = (
  mainProduct: MainProduct, 
  pendantProductVariantId: string
) => {
  const pendantProductVariant = mainProduct.metafields.pendantProducts
    .flatMap(pendantProduct => pendantProduct.variants)
    .find(pendantProductVariant => Number(pendantProductVariant.id) === Number(pendantProductVariantId))

  return pendantProductVariant
}